// extracted by mini-css-extract-plugin
module.exports = {"landingPage":"Landing_landingPage__qrizK","specialButton":"Landing_specialButton__3UI0j","background":"Landing_background__3qWNZ","gif":"Landing_gif__3zv4R"};